module.exports = __webpack_public_path__ + "img/american-express.8eef49f.svg";